module.exports = __webpack_public_path__ + "img/min.f10400a9.png";